module.exports = ["app.issues.link","app.docs.view.link","app.title.long","app.version.text","app.lang.en","app.lang.fr","check.protectiveeyewear.type.label","compute.result.stanag2920.label","standard.stanag4296.label","standard.milprf31013.label","standard.mildtl43511d.label","compute.massvelocity.mass.unit.gr"]


//////////////////
// WEBPACK FOOTER
// ./src/lang/whitelist_fr.json
// module id = 142
// module chunks = 0